import PageContainerBlank from '../components/PageContainer/PageContainerBlank'
import PageEndBlank from '../components/PageContainer/PageEndBlank';

const NotFound = () => {
	return (
		<div>
			<PageContainerBlank />
			<br /><br /><br />
			<h1>404: Page Not Found</h1>
			<h2>How did you get here!?</h2>
			<PageEndBlank />
		</div>
	);
};

export default NotFound;
